<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">Aides à la vente</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body">
        <loading :active.sync="isLoading" 
            :can-cancel="false" 
            :is-full-page="true">
        </loading>
        <!-- NAME + ACTION BTN -->
          <div class="row" v-if="rid==1" >
            <div class="col-lg-12 text-right">
                <el-button type="success float:right" @click="addAideVente()" class="btn-action"><i class="fa fa-plus-circle"></i></el-button>
            </div>
          </div>
        <!-- /NAME + ACTION BTN -->
        <!-- LIST AIDES -->
          <hr data-content="Aides à la vente" class="hr-text">
          <div class="row">
            <div class="col-lg-3 mb-3" v-for="aide in aides_ventes " :key="aide.goodies_id" v-if="aide.type == '1'">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{aide.nom}}</span>
                  <!-- <a @click.prevent="deleteAide(aide.goodies_id)" style="float: right; padding: 3px 0; cursor:pointer"><i class="fa fa-trash" style="color:red"></i></a> -->
                </div>
                <a href="#" @click.prevent="downloadFile(aide.goodies_id)" v-if="aide.filename">Télécharger le fichier</a>
              </el-card>
            </div>
          </div>
        <!-- /LIST AIDES -->
        <!-- LIST AIDES GOODIES -->
          <hr data-content="Goodies" class="hr-text">
          <div class="row">
            <div class="col-lg-3 mb-3" v-for="aide in aides_ventes " :key="aide.goodies_id" v-if="aide.type == '2'">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{aide.nom}}</span>
                  <!-- <a @click.prevent="deleteAide(aide.goodies_id)" style="float: right; padding: 3px 0; cursor:pointer"><i class="fa fa-trash" style="color:red"></i></a> -->
                </div>
                <a href="#" @click.prevent="downloadFile(aide.goodies_id)" v-if="aide.filename">Télécharger le fichier</a>
              </el-card>
            </div>
          </div>
        <!-- /LIST AIDES -->
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Button, Card} from 'element-ui'
  import Loading from 'vue-loading-overlay';
  import swal from 'sweetalert2'
  import 'vue-loading-overlay/dist/vue-loading.css';
  import VueJwtDecode from 'vue-jwt-decode'
  Vue.use(Button)
  Vue.use(Card)
  export default {
    components: {
      Loading
    },
    methods: {
      async getAides() {
        const self = this;
        this.aides_ventes = []
        const response = await fetch(this.$api_url+'/aides_ventes', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            Object.keys(json).forEach(function (key) {
              self.aides_ventes.push(json[key])
            })
            self.log_api("success", 'GET aides_ventes', '', json)
            this.isLoading = false
            return json
          }
        }
        this.isLoading = false
      },
      async downloadFile(goodies_id) {
        this.isLoading = true
        const self = this;
        const response = await fetch(this.$api_url+'/aides_ventes/'+goodies_id+'/file', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            const linkSource = `data:application/octet-stream;base64,${json.file}`;
            const downloadLink = document.createElement("a");
            const fileName = json.filename;

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            self.log_api("success", 'GET /aides_ventes/'+goodies_id+'/file', '', json)

          }
        }
        this.isLoading = false
      },
      async addAideVente() {
        let html = '<center>'
        html += '<br><b>Nom :</b>'+
          '<input type="text" value="" class="form-control" id="input-nom"><br>'+
          
          '<b>Type de l\'aide :</b>'+
          '<select class="form-control" id="select-type">'+
            '<option value="1" selected>Aide à la vente</option>'+
            '<option value="2">Goodies</option>'+
          '</select><br>'+

          '<b>Fichier :</b>'+
          '<input type="file" class="form-control" id="file-contentFile"/><br>'+
          '</center>'


        let evenement = await swal({
          title: 'Ajouter une aide à la vente',
          html: html,
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Enregistrer',
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Annuler',
          buttonsStyling: false
        });
        const self = this;
        if(evenement) { 
          const params = new FormData();
          params.append('nom', document.getElementById('input-nom').value);
          params.append('type', document.getElementById('select-type').value);
          params.append('contentFile', document.getElementById('file-contentFile').files[0]);
          if(document.getElementById('input-nom').value == "") {
            this.notifyVue('top','center', 'danger', 'Le champ nom est manquant!', 'fa fa-thumbs-down')
            return false;
          }
          const response2 = await fetch(this.$api_url+'/aides_ventes', {
            method: 'POST',
            credentials: 'include',
            body: params
            });
          const json2 = await response2.json();
          if(json2.code != 409) {
            this.notifyVue('top','center', 'success', 'Aide à la vente ajouté! 😄', 'fa fa-thumbs-up')
            self.log_api("success", "POST aides_ventes", params, json2)

            this.getAides()
          } else {
            this.notifyVue('top','center', 'danger', 'Une erreur est survenue! 😱', 'fa fa-thumbs-down')
            self.log_api("error", "POST aides_ventes", params, json2)

            this.getAides()
          }
        }
      },
      async deleteAide(goodies_id) {
        this.isLoading = true
        const self = this;
        const response = await fetch(this.$api_url+'/aides_ventes/'+goodies_id, {
          method: 'DELETE',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            this.notifyVue('top','center', 'success', 'Aide supprimé! 😄', 'fa fa-thumbs-up')
            self.log_api("success", 'DELETE /aides_ventes/'+goodies_id, '', json)
            this.getAides()
          } else {
            this.notifyVue('top','center', 'danger', 'Une erreur est survenue! 😱', 'fa fa-thumbs-down')
            self.log_api("error", 'DELETE /aides_ventes/'+goodies_id, '', json)
            this.getAides()
          }
        }
        this.isLoading = false
      },
      notifyVue (verticalAlign, horizontalAlign, color, message, icon) {
        this.$notify(
        {
          message: message,
          icon: icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: color
        })
      },
      JSON_to_URLEncoded(obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push((v !== null && typeof v === "object") ?
              this.JSON_to_URLEncoded(v, k) :
              encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return str.join("&");
      },
    },
    computed: {

    },
    data () {
      return {
        isLoading: true,
        aides_ventes: [],
        rid: VueJwtDecode.decode(localStorage.getItem('token')).id.rid
      }
    },
    mounted() {
      this.getAides();
    },
  }
</script>

<style lang="scss">
  hr {
    margin-top:30px
  }
  hr.hr-text {
    position: relative;
    border: none;
    height: 1px;
    background: rgb(223, 223, 223);
  }
  hr.hr-text::before {
    content: attr(data-content);
    display: inline-block;
    background: #fff;
    font-weight: bold;
    font-size: 1rem;
    color: black;
    border-radius: 30rem;
    padding: 0.2rem 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>